<template>
  <div>
    <div class="page-header clear-filter" filter-color="">
      <parallax
        class="page-header-image"
        style="background-image:url('img/prod.jpeg')"
      >
      </parallax>
      <div class="container">
        <h2 class="title mt-5">{{ $t('portofolio.hero.title') }}</h2>
      </div>
    </div>
    <div class="section mt-n4 mb-4 justify-content-center">
      <div class="section ">
      <div class="container">
        <h2 class="font-weight-bold mt-n4" style="color: #008c45;">
          <img
            src="img/icon/icon (21).png" alt=""
            width="4%"
            class="mr-3"
          />
          {{ $t('portofolio.section.heading') }}
        </h2>
        <div class="card container" style="border-radius: 2%">
          <h3 class="font-weight-bold mt-4">{{ $t('portofolio.section.experiencedTitle') }}</h3>
          <div class="row mt-4">
            <div class="col-lg-8">
              <div class="card slide-up container text-white" style="background: #008c45; border-radius: 2%;">
                <h5 class="font-weight-bold align-middle mt-3">{{ $t('portofolio.section.achievements.title') }}</h5>
                <p>
                  <img
                    src="img/icon/icon (20).png" alt=""
                    width="4%"
                    class="ml-3 mr-3"
                  />3,455+ {{ $t('portofolio.section.achievements.projectsSuffix') }} <br><br>
                  <img
                    src="img/icon/icon (20).png" alt=""
                    width="4%"
                    class="ml-3 mr-3"
                  />{{ $t('portofolio.section.achievements.exportedPrefix') }} 16 {{ $t('portofolio.section.achievements.countriesSuffix') }} <br><br>
                  <img
                    src="img/icon/icon (20).png" alt=""
                    width="4%"
                    class="ml-3 mr-3"
                  />{{ $t('portofolio.section.achievements.fabricationPrefix') }} 40+ {{ $t('portofolio.section.achievements.typeOfMaterialsSuffix') }} <br><br>
                  <img
                    src="img/icon/icon (20).png" alt=""
                    width="4%"
                    class="ml-3 mr-3"
                  />{{ $t('portofolio.section.achievements.customersPrefix') }} 350+ {{ $t('portofolio.section.achievements.customersSuffix') }} (570 {{ $t('portofolio.section.achievements.plantsSuffix') }}) <br><br>
                </p>
              </div>
              <div class="card slide-up container text-white" style="background: #008c45; border-radius: 2%;">
                <h5 class="font-weight-bold align-middle mt-3">{{ $t('portofolio.section.materialCategories.title') }}</h5>
                  <div class="row">
                    <div class="col-6">
                      <n-button type="default" size="sm" class="btn btn-round btn-lg btn-block text-left" style="padding: 10px; background-color: #006400;">
                        <div class="row">
                          <div class="col-3">
                            <img
                            src="img/icon/icon (22).png" alt=""
                            width="60%"
                            class=""
                          />
                          </div>
                          <div class="col-9">
                            <span class="ml-n4" style="font-size:15px;">{{ $t('portofolio.section.materialCategories.niBaseAlloy') }}</span><br>
                            <span class="ml-n4"> {{ $t('portofolio.section.materialCategories.examplePrefix') }} Alloy C-276, Alloy 625, Alloy 600 </span>
                          </div>
                        </div>
                      </n-button>
                      <n-button type="default" size="sm" class="btn btn-round btn-lg btn-block text-left" style="padding: 10px; background-color: #00874B;">
                        <div class="row">
                          <div class="col-3">
                            <img
                            src="img/icon/icon (22).png" alt=""
                            width="60%"
                            class=""
                          />
                          </div>
                          <div class="col-9">
                            <span class="ml-n4" style="font-size:15px;">{{ $t('portofolio.section.materialCategories.titaniumZirconium') }}</span><br>
                            <span class="ml-n4"> {{ $t('portofolio.section.materialCategories.examplePrefix') }} Ti Gr.2, Zr702 </span>
                          </div>
                        </div>
                      </n-button>
                      <n-button type="default" size="sm" class="btn btn-round btn-lg btn-block text-lef mb-4" style="padding: 10px; background-color: #006400;">
                        <div class="row">
                          <div class="col-3">
                            <img
                            src="img/icon/icon (22).png" alt=""
                            width="60%"
                            class=""
                          />
                          </div>
                          <div class="col-9">
                            <span class="ml-n4" style="font-size:15px;">{{ $t('portofolio.section.materialCategories.duplexSteel') }}</span><br>
                            <span class="ml-n4"> {{ $t('portofolio.section.materialCategories.examplePrefix') }} SAF2205, S31803 </span>
                          </div>
                        </div>
                      </n-button>
                    </div>
                    <div class="col-6">
                      <n-button type="default" size="sm" class="btn btn-round btn-lg btn-block text-left" style="padding: 10px; background-color: #006400;">
                        <div class="row">
                          <div class="col-3">
                            <img
                            src="img/icon/icon (22).png" alt=""
                            width="60%"
                            class=""
                          />
                          </div>
                          <div class="col-9">
                            <span class="ml-n4" style="font-size:15px;">{{ $t('portofolio.section.materialCategories.austeniticSS') }}</span><br>
                            <span class="ml-n4"> {{ $t('portofolio.section.materialCategories.examplePrefix') }} 304, 316L </span>
                          </div>
                        </div>
                      </n-button>
                      <n-button type="default" size="sm" class="btn btn-round btn-lg btn-block text-left" style="padding: 10px; background-color: #00874B;">
                        <div class="row">
                          <div class="col-3">
                            <img
                            src="img/icon/icon (22).png" alt=""
                            width="60%"
                            class=""
                          />
                          </div>
                          <div class="col-9">
                            <span class="ml-n4" style="font-size:15px;">{{ $t('portofolio.section.materialCategories.others.name') }}</span><br>
                            <span class="ml-n4"> {{ $t('portofolio.section.materialCategories.others.example') }} </span>
                          </div>
                        </div>
                      </n-button>
                    </div>
                  </div>

              </div>
            </div>
            <div class="col-lg-4">
              <div class="card slide-up container text-white" style="background: #008c45; border-radius: 2%;">
                <h5 class="font-weight-bold align-middle mt-3 mb-5">{{ $t('portofolio.section.applicationAreas.title') }}</h5>
                <p>
                  <img
                    src="img/icon/icon (23).png" alt=""
                    width="7%"
                    class="ml-3 mr-3"
                  />{{ $t('portofolio.section.applicationAreas.towerColumn') }} <br><br>
                  <img
                    src="img/icon/icon (24).png" alt=""
                    width="7%"
                    class="ml-3 mr-3"
                  />{{ $t('portofolio.section.applicationAreas.vesselReactor') }} <br><br>
                  <img
                    src="img/icon/icon (25).png" alt=""
                    width="15%"
                    class="mr-3"
                  />{{ $t('portofolio.section.applicationAreas.heatExchanger') }} <br><br>
                  <img
                    src="img/icon/icon (9).png" alt=""
                    width="10%"
                    class="ml-3 mr-3"
                  />{{ $t('portofolio.section.applicationAreas.piping') }} <br><br>
                  <img
                    src="img/icon/icon (26).png" alt=""
                    width="9%"
                    class="ml-3 mr-3"
                  />{{ $t('portofolio.section.applicationAreas.muffle') }} <br><br>
                  <img
                    src="img/icon/icon (27).png" alt=""
                    width="7%"
                    class="ml-3 mr-3"
                  />{{ $t('portofolio.section.applicationAreas.radiantTube') }} <br><br>
                  <img
                    src="img/icon/icon (11).png" alt=""
                    width="9%"
                    class="ml-3 mr-3"
                  />{{ $t('portofolio.section.applicationAreas.others') }} <br><br>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      
    </div>

    <div class="dashboard">
      <div class="container mb-5">
        <h2 class="font-weight-bold mt-4 text-left" style="color: #008c45;">
          <img
            src="img/icon/icon (21).png" alt=""
            width="4%"
            class="mr-3"
          />
          {{ $t('portofolio.dashboard.heading') }}
        </h2>
        <h2>{{ $t('portofolio.dashboard.subheading') }}</h2>
        <div class="chart-container">
          <div class="chart-box">
            <h3>{{ $t('portofolio.dashboard.byProduct') }}</h3>
            <PieChart :chartData="productData" />
          </div>
          <div class="chart-box">
            <h3>{{ $t('portofolio.dashboard.byMaterial') }}</h3>
            <PieChart :chartData="materialData" />
          </div>
          <div class="chart-box">
            <h3>{{ $t('portofolio.dashboard.byCountry') }}</h3>
            <PieChart :chartData="countryData" />
          </div>
        </div>
      </div>
    </div>

    <!-- MOTO TOKKI  -->
    <div class="page-header clear-filter moto-office-section" filter-color="purple">
      <div class="parallax">
        <div class="container" style="">
          <h1 class="text-white text-left pt-5 font-weight-bold text-center">START <span style="font-size: 20px; color: yellow;"> {{ $t('common.offices.motoStartWithTokki') }} </span></h1>
          <div class="row pt-5 mt-n4">
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.mainOfficeFactory') }}  :</span></h6>
              Kawasan Industri Jababeka 1
              Jl.Jababeka XIIB Blok W26
              Cikarang-Bekasi, Jawa Barat Indonesia Kode Pos 17530
              Telp: +62-21 893 6733 (Hunting) <br><br>

              Phone : +62 - 21 8936733 (Hunting)<br>
              Fax   : +62 - 21 8936738<br>
              Email : sales@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.secondOfficeFactory') }}</span></h6>
              Kawasan Industri Krakatau 1,
              Jl. Australia I Kav. C1/2, Kel. Warnasari, Kec. Citangkil
              Kota Cilegon, Banten - Indonesia 42443 <br><br>

              Phone : +62 - 254 8317244<br>
              Fax   : +62 - 254 8317244<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.thirdOfficeFactory') }}</span></h6>
              Pergudangan AKR GEM City F-09, Kabupaten Gresik, Jawa Timur <br><br><br>

              Phone : +62 - 31 39935914<br>
              Fax   : +62 - 31 39935914<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left mb-5">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.fourthMarketingOffice') }}</span></h6>
              Jl. Gn. Leuser, Tj. Marulak, Kec. Rambutan, Kota Tebing Tinggi, Sumatera Utara 20998 <br><br><br>

              Phone : +62 811-1972-2507<br>
              Email : sales@tef.co.id<br>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { Carousel, CarouselItem, Button } from 'element-ui';
import PieChart from '@/components/PieChart.vue'

export default {
  name: 'profile',
  bodyClass: 'profile-page',
  components: {
    [Button.name]: Button,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    PieChart
  },
  data () {
    return {
      options: {
        responsive: true,
        legend: {
          position: 'right',
          labels: {
            fontSize: 12
          }
        }
      },
      // chartData: {
      //   labels: ['Indonesia', 'China', 'Japan'],
      //   datasets: [
      //     {
      //       data: [44, 41, 6],
      //       backgroundColor: ['#008000', '#ff4d4d', '#8A2BE2']
      //     }
      //   ]
      // },
      productData: {
        labels: ['Piping 17 %', 'R/T 18 %', 'Muffle 7 %', 'PSP 1 %', 'Other 29 %', 'Vessel 13 %', 'Tower 2 %', 'H/E 12 %'],
        datasets: [{
          data: [17, 18, 7, 1, 29, 13, 2, 12],
          backgroundColor: ['#006d39', '#009966', '#f28c44', '#c5f23c', '#e8b58a', '#ff6f70', '#ff4c4c', '#bd245f']
        }]
      },
      materialData: {
        labels: ['Ni Base Alloy 59 %', 'Cu-Ni 0.4 %', 'Titanium 9 %', 'Austenitic S.S. 22 %', 'Duplex S.S. 2 %', 'Other 2 %'],
        datasets: [{
          data: [59, 0.4, 9.4, 22, 2, 2],
          backgroundColor: ['#1E90FF', '#90EE90', '#B57EDC', '#87CEEB', '#FFD700', '#c5f23c']
        }]
      },
      countryData: {
        labels: ['Indonesia 44 %', 'Japan 41 %', 'Thailand 6 %', 'Singapore 3 %', 'China 3 %', 'Malaysia 2 %', 'India 1 %', 'Philiphine 0 %'],
        datasets: [{
          data: [44, 41, 6, 3, 3, 2, 1, 0],
          backgroundColor: ['#006d39', '#009966', '#F18C42', '#FF6F71', '#FF474C', '#E84850', '#bd245f', '#6700cc']
        }]
      }
    }
  },
  mounted(){
      this.fillData();
    },
  methods: {
    fillData () {
      this.productData = {
        labels: ['Piping', 'R/T', 'Muffle', 'PSP', 'Other', 'Vessel', 'Tower', 'H/E'],
        datasets: [{
          data: [17, 18, 29, 7, 12, 2, 13, 1],
          backgroundColor: ['#006d39', '#009966', '#f7967a', '#e3e354', '#e0dfdf', '#fe9b91', '#c85a84', '#a8518a']
        }]
      }
    },


  }
};
</script>

<style scoped>
.dashboard {
  background: #e4e4e4;
  padding: 30px;
  border-radius: 12px;
  text-align: center;
}
.chart-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-top: 20px;
}
.chart-box {
  background: white;
  border: 2px solid #0f9a6c;
  border-radius: 15px;
  padding: 20px;
  width: 300px;
  margin: 10px;
}
h2 {
  font-size: 20px;
  font-weight: bold;
}
h3 {
  margin-bottom: 15px;
}

.moto-office-section {
  max-height: none;
  height: auto;
  overflow: visible;
  padding-bottom: 40px;
}

.moto-office-section .parallax {
  height: auto;
  padding-bottom: 40px;
}
</style>
